import Echo from 'laravel-echo';
import Pusher from 'pusher-js';
import { Dispatch, SetStateAction } from 'react';
import { customObjValues } from '../../formatters';
import { FuneralService } from '../../types';

declare global {
  interface Window {
    Pusher: any;
  }
}
window.Pusher = Pusher;

export function switchEchoChannel(
  echoData: {
    echoConnection: Echo | undefined;
    code: string;
    viewerStats: boolean;
  },
  serviceData: {
    service?: FuneralService;
    viewerCount: number;
    isLive: boolean;
    selectedSource;
  },
  setters: {
    setLive;
    setLiveSources;
    setViewerStats;
    setViewerCount;
    setSelectedSource;
  },
) {
  if (!echoData.echoConnection) return;

  let echo;
  if (echoData.echoConnection.options.cluster === 'soketi') {
    echo = echoData.echoConnection.channel(`funeral.${echoData.code}`);
  } else {
    echo = echoData.echoConnection.private(`funeral.${echoData.code}`);
  }

  echo
    .on('pusher:subscription_count', (e) => {
      if (e?.subscription_count) {
        setters.setViewerCount(e.subscription_count);
      }
    })
    .on('pusher:subscription_succeeded', (e) => {
      if (e?.subscription_count) {
        setters.setViewerCount(e.subscription_count);
      }
    })
    .on('pusher:subscription_succeeded', (e) => {
      setters.setViewerCount(e.subscription_count);
    })
    .listen('StreamStarted', (e: { sources }) => {
      setters.setLive(true);
      setters.setLiveSources(e.sources);
      if (!e.sources.some((source) => customObjValues(source)[0][0].url === customObjValues(serviceData.selectedSource)[0][0].url)) {
        setters.setSelectedSource(e.sources[0]);
      }
    })
    .listen('StreamStopped', (e: { sources }) => {
      setters.setLive(e.sources.length > 0);

      setters.setLiveSources(e.sources);
      if (!e.sources.some((source) => customObjValues(source)[0][0].url === customObjValues(serviceData.selectedSource)[0][0].url)) {
        setters.setSelectedSource(e.sources[0]);
      }
    })
    .listen('ViewerStatsChanged', (e: { viewerStats: boolean }) => {
      setters.setViewerStats(e.viewerStats);
    })
    .listen('StreamTimeChange', () => {
      setTimeout(() => location.reload(), Math.random() * 10000);
    })
    .listen('StreamSourceChange', (e: { sources }) => {
      // if (!serviceData.isLive) return;
      setters.setLiveSources(e.sources);
      if (
        !e.sources.some((source) => customObjValues(source)[0][0].url === customObjValues(serviceData.selectedSource)[0][0].url) &&
        !serviceData.selectedSource
      ) {
        setters.setSelectedSource(e.sources[0]);
      }
    })
    .listen('ForceEmbedRefresh', () => {
      setTimeout(() => location.reload(), Math.random() * 10000);
    })
    .error((error: Error) => {
      console.error(error);
      setters.setViewerStats(false);
    });
}

export function connectToEcho(
  setEcho: Dispatch<SetStateAction<Echo | undefined>>,
  settings: { wss_key?: string; pusher_cluster?: string; wss_auth_url?: string; wss_host: string; wss_port: number },
) {
  if (!settings?.pusher_cluster || !settings.wss_key) return;
  if (settings.pusher_cluster === 'soketi') {
    setEcho(
      new Echo({
        broadcaster: 'pusher',
        wsHost: settings.wss_host,
        key: settings.wss_key,
        cluster: settings.pusher_cluster,
        authEndpoint: settings.wss_auth_url,
        wssPort: settings.wss_port,
        enabledTransports: ['ws'],
      }),
    );
  } else {
    setEcho(
      new Echo({
        broadcaster: 'pusher',
        key: settings.wss_key,
        cluster: settings.pusher_cluster,
        forceTLS: true,
        authEndpoint: settings.wss_auth_url,
      }),
    );
  }
}
